import Index from '@/pages/role/Index'
import List from '@/pages/role/List'
import Create from '@/pages/role/Create'
import Modify from '@/pages/role/Modify'

var serviceName = process.env.VUE_APP_SERVICE_NAME || 'Nichibyo'

export default {
  path: 'role',
  component: Index,
  children: [
    {
      path: 'index',
      component: List
    },
    {
      path: 'create',
      component: Create,
      props: () => ({serviceName: serviceName})
    },
    {
    path: 'modify/:id',
    component: Modify,
    props: () => ({serviceName: serviceName})
    }
  ]
}